export default __webpack_public_path__ + "static/media/coldsiemens.e061a63c.png";